// extracted by mini-css-extract-plugin
export default {"loginForm":"Password_loginForm__O6bAz"};